<template>
	<div class="rich-text-input-field">
		<default-widget-field v-bind="defaultFieldProps" v-on="defaultFieldListeners" />
		<CombinedInputFieldDataMenu
			:ref="fieldRef"
			dontShowInsertData
			:value.sync="value"
			:isLongText="isLongText"
			:placeholder="placeholder"
			class="widget-input-field widget-text-field-layout"
			:richTextFormat="richTextFormat"
			v-bind="activeFormFieldCommonProps"
			:valuesTypes="dataInputMenuValueTypes"
		/>
	</div>
</template>

<script>
import CombinedInputFieldDataMenu from '@/components/DataInput/CombinedInputFieldDataMenu';
import DefaultWidgetField from './DefaultWidgetField';

import WidgetFieldMixin from './WidgetFieldMixin';
import ItemOnlyAllowedValueTypesMixin from '../FieldSettings/ValueTypesMixins/ItemOnlyAllowedValueTypesMixin';

import { TEXT_BOX_FORMAT_TYPES } from '@/components/common/RichTextBox/rich-text-box.const';

export default {
	name: 'RichTextInputField',
	components: {
		DefaultWidgetField,
		CombinedInputFieldDataMenu,
	},
	mixins: [WidgetFieldMixin, ItemOnlyAllowedValueTypesMixin],
	computed: {
		placeholder() {
			const placeholder = this.getOption('placeholder');
			return placeholder.enabled ? placeholder.value : '';
		},
		richTextFormat() {
			return TEXT_BOX_FORMAT_TYPES.HTML; // RichText input always receives and outputs HTML
		},
		isLongText() {
			return this.field.metadata.options.longText?.enabled;
		},
	},
};
</script>

<style scoped lang="scss">
.rich-text-input-field {
	padding-bottom: 30px;

	::v-deep {
		input:-webkit-autofill {
			// remove chrome blue background on autocomplete input
			&,
			&:hover,
			&:focus,
			&:active {
				-webkit-box-shadow: 0 0 0 30px white inset !important;
			}
		}
	}

	@media (max-width: $device-sm) {
		::v-deep(.ProseMirror) {
			background-color: var(--widget-field-mobile-bg) !important;
		}
	}
}
</style>
